class ImageSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.interval = parseInt(this.getAttribute('interval')) || 5000;
      this.showNavigation = this.getAttribute('navigation') === 'true';
      this.autoplayTimer = null;
      this.interval = this.getAttribute('interval') === '0000' ? 0 : this.interval;
      this.sliderStyle = this.getAttribute('slider-style') || 'slider';
    }
  
    connectedCallback() {
      this.setupSlider();
      if (this.showNavigation) {
        this.createControls();
      }
      this.startAutoplay();
    }
  
    setupSlider() {
      this.style.display = 'block';
      this.style.position = 'relative';
      this.style.overflow = 'hidden';
      // this.style.maxHeight = '100vh';
      
      const wrapper = document.createElement('div');
      wrapper.style.cssText = `
        display: flex;
        transition: transform 0.5s ease;
        height: 100%;
        min-height: 500px;  
        // max-height: 100vh;
      `;
      
      const slides = Array.from(this.getElementsByClassName('slider-item'));
      
      if (this.sliderStyle === 'carousel') {
        // For carousel, append first slide at the end for smooth transition
        const firstSlideClone = slides[0].cloneNode(true);
        slides.push(firstSlideClone);
      }
      
      slides.forEach(slide => {
        wrapper.appendChild(slide.cloneNode(true));
      });
      
      this.innerHTML = '';
      this.appendChild(wrapper);
      this.wrapper = wrapper;
      this.slidesCount = slides.length;
    }
  
    createControls() {
      const prevBtn = document.createElement('button');
      prevBtn.innerHTML = '&#10094;';
      prevBtn.classList.add('slider-control', 'prev');
      prevBtn.onclick = () => this.prevSlide();
      
      const nextBtn = document.createElement('button');
      nextBtn.innerHTML = '&#10095;';
      nextBtn.classList.add('slider-control', 'next');
      nextBtn.onclick = () => this.nextSlide();
      
      const controlsStyle = document.createElement('style');
      controlsStyle.textContent = `
        .slider-control {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 0);
          // backdrop-filter: blur(5px);
          border: none;
          padding: 1rem;
          cursor: pointer;
          font-size: 1.5rem;
          z-index: 1;
          transition: all 0.3s ease;
          font-size: 2rem;
        }
        .slider-control:hover {
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0);
        }
          .slider-control:active {
          background: none;
          outline: none;
        }
        .prev { left: 1rem; }
        .next { right: 1rem; }
      `;
      
      this.appendChild(controlsStyle);
      this.appendChild(prevBtn);
      this.appendChild(nextBtn);
    }
  
    nextSlide() {
      const totalSlides = this.getElementsByTagName('img').length;
      
      if (this.sliderStyle === 'carousel') {
        if (this.currentSlide === totalSlides - 1) {
          this.wrapper.style.transition = 'none';
          this.currentSlide = 0;
          this.updateSlidePosition();
          
          this.wrapper.offsetHeight;
          
          this.wrapper.style.transition = 'transform 0.5s ease';
          this.currentSlide = 1;
        } else {
          this.currentSlide++;
        }
      } else {
        this.currentSlide = (this.currentSlide + 1) % totalSlides;
      }
      
      this.updateSlidePosition();
      this.resetAutoplay();
    }
  
    prevSlide() {
      const totalSlides = this.getElementsByTagName('img').length;
      
      if (this.sliderStyle === 'carousel') {
        if (this.currentSlide === 0) {
          this.currentSlide = totalSlides - 1;
        } else {
          this.currentSlide--;
        }
      } else {
        this.currentSlide = (this.currentSlide - 1 + totalSlides) % totalSlides;
      }
      
      this.updateSlidePosition();
      this.resetAutoplay();
    }
  
    updateSlidePosition() {
      this.wrapper.style.transform = `translateX(-${this.currentSlide * 100}%)`;
    }
  
    startAutoplay() {
      if (this.interval > 0) {
        this.autoplayTimer = setInterval(() => this.nextSlide(), this.interval);
      }
    }
  
    resetAutoplay() {
      clearInterval(this.autoplayTimer);
      this.startAutoplay();
    }
  
    disconnectedCallback() {
      clearInterval(this.autoplayTimer);
    }
  }
  
  customElements.define('image-slider', ImageSlider);